import React, { useEffect } from "react";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import styles from "./SearchBar.module.css";
import { useSelector } from "react-redux";
import { searchConfigItem } from "../../../api/config/ConfigService";
import { useState } from "react";
import userService from "../../../api/users/UsersConfig";
import { agencieSearch } from "../../../api/agencies/AgenciesService";

export const SearchBar = (props) => {
  const user_service = userService();
  const {
    keys,
    result,
    onSelect,
    primaryColor,
    format,
    placeholder,
    component,
  } = props;
  const { activeOrganization } = useSelector((state) => state.gamma);
  const [inputResult, setinputResult] = useState("");
  const [inputSearch, setinputSearch] = useState("");

  useEffect(() => {
    async function setAgency() {
      switch (component) {
        case "users":
          user_service.searchUser(inputSearch).then((res) => {
            setinputResult(res.content);
          });
          break;
        case "sale_points":
          await agencieSearch(inputSearch)
            .then((res) => {
              setinputResult(res.content);
            })
            .catch((error) => console.log(error));
          break;
        case "configuration":
          await searchConfigItem(inputSearch).then((res) => {
            setinputResult(res.content);
          });
          break;
        default:
          setinputResult("");
      }
    }
    setAgency();
  }, [inputSearch, activeOrganization, component, user_service]);

  return (
    <div className={styles.searchBarContainer}>
      <ReactSearchAutocomplete
        items={inputResult}
        inputDebounce={1000}
        onSearch={(e) => setinputSearch(e)}
        fuseOptions={keys}
        resultStringKeyName={result}
        placeholder={placeholder}
        onSelect={onSelect}
        formatResult={format}
        styling={{
          height: "3rem",
          fontSize: "1rem",
          fontFamily: "Roboto, sans-serif",
          border: `2px solid ${primaryColor}`,
          borderRadius: "10px",
          hoverBackgroundColor: primaryColor,
          zIndex: 20,
          transition: "0.5s",
        }}
      />
    </div>
  );
};
